import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const adsApi = {
  getAllAds: (params) => {
    const url = "advertising";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getAds: (id) => {
    const url = "advertising";
    return axiosClient.get(url + "/" + id);
  },

  createAds: (params) => {
    const url = "advertising";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateAds: (id, payload) => {
    const url = "advertising/";
    return axiosClient.patch(url + id, payload);
  },
  deleteAds: (params) => {
    const url = "advertising";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default adsApi;
